import { render, staticRenderFns } from "./CanvasDrawingBase.vue?vue&type=template&id=06180034&scoped=true&lang=pug"
import script from "./CanvasDrawingBase.vue?vue&type=script&lang=ts"
export * from "./CanvasDrawingBase.vue?vue&type=script&lang=ts"
import style0 from "./CanvasDrawingBase.vue?vue&type=style&index=0&id=06180034&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06180034",
  null
  
)

export default component.exports